<template>
  <div class="chat w-100">
    <div class="text-left">
      <b-col lg="12" md="3" class="text-left">
        <router-link :to="{ name: 'Tickets' }">
          <b-button pill class="col-lg-4 btn btn-purple">بازگشت</b-button>
        </router-link>
      </b-col>
    </div>

    <div class="bg- p-2 m-3 border-bottom-header-chat rounded">
      <div class="row m-3">
        <b-col lg="4" md="4">
          <b-row>
            <div class="col-lg-12 text-sm-center">
              <img
                  class="chat-img rounded rounded-circle p-1"
                  :src="require('@/assets/avatar.jpg')"
                  alt="avatar"
              />
              <span class="mr-1">{{ ticket.user.name }}</span>
            </div>
          </b-row>
        </b-col>

        <b-col lg="4" md="4">
          <div class="pt-4 text-sm-center">
            <p>اولویت: {{ ticket.priority.meta_key }}</p>
          </div>
        </b-col>

        <b-col lg="4" md="4">
          <div class="pt-4 text-sm-center">
            <p>وضعیت: {{ ticket.status.meta_key }}</p>
          </div>
        </b-col>
      </div>
      <div class="row m-3">
        <div class="p-2 m-1 col-lg-4 col-md-4 text-sm-center">
          <span>عنوان:</span>
          <span> {{ ticket.name }}</span>
        </div>
        <div class="p-2 m-1 col-lg-4 col-md-4 text-sm-center">
          <span>نوع:</span>
          <span> {{ ticket_types[ticket.ticket_type] }}</span>
        </div>
      </div>
    </div>
    <!-- end chat-header -->
    <div class="chat-history" id="ticket_message">
      <ul>
        <message
            v-for="message in ticket.messages"
            :message="message"
            :user="ticket.user"
            :key="message.id"
        />
      </ul>
    </div>

    <!-- end chat-history -->
    <form @submit.prevent="onSubmit">

      <form-group class="my-4" :validations="$v.form.message_for_send">
        <div slot-scope="{ errors, invalid }">
          <label for="" class="mt-4 "> توضیحات </label>
          <b-form-textarea class="border border-1 chat-message clearfix"
                           id="textarea-small"
                           rows="3"
                           placeholder=" پیام خود را وارد کنید "
                           v-model="form.message_for_send"
          ></b-form-textarea>
          <form-errors-manager class="" :errors="errors"/>
        </div>
      </form-group>


      <form-group class="my-2" :validations="$v.form.files">
        <div slot-scope="{ errors, invalid }">

          <b-form-group>
            <b-form-file class="text-left" v-model="form.files" multiple placeholder="" browse-text="انتخاب فایل"
                         id="file-default"></b-form-file>
          </b-form-group>
          <form-errors-manager class="" :errors="errors"/>
        </div>
      </form-group>

      <div class="text-left">
        <b-col lg="12" md="12" class="text-left">
          <b-col class="text-left">
            <b-button
                type="submit"
                pill
                class="col-md-4 col-sm-12 btn btn-purple"
            >ارسال
            </b-button
            >
          </b-col>
        </b-col>
      </div>
    </form>
    <!-- end chat-message -->
  </div>
  <!-- end chat -->

  <!-- end container -->
</template>

<script>
import {required} from "vuelidate/lib/validators";
import FormGroup from "../../../components/validator/FormGroup.vue";
import FormErrorsManager from "../../../components/validator/FormErrorsManager.vue";
import {mapGetters} from "vuex";
import Message from "./Message.vue";
import {ticket_types} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Ticket";

export default {
  name: "tableItems",
  components: {
    FormGroup,
    FormErrorsManager,
    Message,
  },

  props: ["title", "submitFunction", "message", "user"],
  data() {
    return {
      ticket_types,
      fetchMessageCondition: '',
      form: {
        message_for_send: "",
        files: []
      },
    };
  },
  validations: {
    form: {
      message_for_send: {required},
      files: {},
    },
  },
  computed: {
    ...mapGetters({
      ticket: "Ticket/getTicket",
    }),
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },

    onSubmit() {
      if (this.invalid()) {
        const user_id = this.$route.params.user;
        this.$store.dispatch("Ticket/reply", {
          form: this.form,
          user_id: user_id,
        });
      }
    },
    updateScroll() {
      var element = document.querySelector(
          "#ticket_message ul .chat:nth-last-child(1)"
      );
      element.scrollIntoView({behavior: "smooth", block: "start"});
    },
    getTicket() {
      const ticket_id = this.$route.params.ticket;
      const user_id = this.$route.params.user;
      this.$store.dispatch("Ticket/getTicket", {
        ticket_id: ticket_id,
        user_id: user_id,
        scroll: false,
      });
    },
  },
  mounted() {
    const ticket_id = this.$route.params.ticket;
    const user_id = this.$route.params.user;
    this.$store.dispatch("Ticket/getTicket", {
      ticket_id: ticket_id,
      user_id: user_id,
      scroll: "ticket_message",
    });
    this.fetchMessageCondition = setInterval(this.getTicket, 5000);
  },
  watch: {
    ticket: {
      handler: function (newValue, oldValue) {
        if (newValue.messages.length != oldValue.messages.length) {
          setTimeout(this.updateScroll, 0);
          this.form.message_for_send = "";
        }
      },
      deep: true,
    },
  },
  destroyed() {
    clearInterval(this.fetchMessageCondition);
  }
};
</script>


<style scoped>
body {
  background: #c5ddeb;

  padding: 40px 0;
  color: white;
}

.container {
  margin: 0 auto;
  width: 750px;
  background: #444753;
  border-radius: 5px;
}

.people-list {
  width: 260px;
  float: left;
}

.people-list .search {
  padding: 20px;
}

.people-list input {
  border-radius: 3px;
  border: none;
  padding: 14px;
  color: white;
  background: #6a6c75;
  width: 90%;
  font-size: 14px;
}

.people-list .fa-search {
  position: relative;
  left: -25px;
}

.people-list ul {
  padding: 20px;
  height: 770px;
}

li {
  list-style: none;
}

.people-list ul li {
  padding-bottom: 20px;
  list-style: none;
}

.people-list img {
  float: left;
}

.people-list .about {
  float: left;
  margin-top: 8px;
}

.people-list .about {
  padding-left: 8px;
}

.people-list .status {
  color: var(--purple);
}

.chat {
  float: left;
  background: #f2f5f8;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #434651;
}

.chat .chat-history {
  padding: 30px 30px 20px;
  border-bottom: 2px solid white;
  overflow-y: scroll;
  height: 575px;
}

.chat .chat-history .message-data {
  margin-bottom: 15px;
}

.chat .chat-history .message-data-time {
  color: #a8aab1;
  padding-left: 6px;
}

.chat .chat-history .message {
  color: white;
  padding: 18px 20px;
  line-height: 26px;
  font-size: 16px;
  border-radius: 7px;
  margin-bottom: 30px;
  width: 90%;
  position: relative;
}

.chat .chat-history .message:after {
  bottom: 97%;
  left: 8%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-bottom-color: var(--light-purple);
  border-width: 10px;
  margin-left: -10px;
}

.chat .chat-history .my-message {
  background: var(--light-purple);
}

.chat .chat-history .other-message {
  background: var(--purple);
}

.chat .chat-history .other-message:after {
  border-bottom-color: var(--purple);
  left: 90%;
}

.chat .chat-message {
  padding: 15px;
}

.chat .chat-message textarea {
  width: 100%;
  border: none;
  padding: 10px 20px;
  margin-bottom: 10px;
  border-radius: 5px;
  resize: none;
}

.chat .chat-message .fa-file-o,
.chat .chat-message .fa-file-image-o {
  font-size: 16px;
  color: gray;
  cursor: pointer;
}

.chat .chat-message button {
  float: right;
  color: var(--purple);
  font-size: 16px;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  font-weight: bold;
  background: #f2f5f8;
}

.chat .chat-message button:hover {
  color: var(--purple);
}

.online,
.offline,
.me {
  margin-right: 3px;
  font-size: 10px;
}

.online {
  color: var(--light-purple);
}

.offline {
  color: #e38968;
}

.me {
  color: var(--purple);
}

.align-left {
  text-align: left;
}

.align-right {
  text-align: right;
}

.float-right {
  float: right;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

.chat-img {
  height: 80px;
}

.border-bottom-header-chat {
  border: 1px solid #cfcfcf;
  background: #dbdbdb;
}


</style>